import React, { useState } from 'react';

import { InsuranceDetails } from 'Api/insurance/types/insurance.types';
import { EmailCancellationAlerts } from './EmailCancellationAlerts';
import { EmailCancellationForm } from './EmailCancellationForm';
import { Container } from './emailCancellationForm.styles';
import { EmailCancellationFormButtons } from './EmailCancellationFormButtons';
import { EmailCancellationFormFields } from './EmailCancellationFormFields';
import { EmailCancellationInfo } from './EmailCancellationInfo';

interface EmailCancellationProps {
  insuranceDetails: InsuranceDetails;
}

export const EmailCancellation = ({
  insuranceDetails,
}: EmailCancellationProps) => {
  const [submitError, setSubmitError] = useState<boolean>(false);
  const [submitSuccess, setSubmitSuccess] = useState<boolean>(false);

  const { agreementProduct, insuranceProduct } = insuranceDetails;

  return (
    <Container>
      <EmailCancellationInfo
        agreementProduct={agreementProduct}
        insuranceProduct={insuranceProduct}
      />
      <EmailCancellationAlerts
        submitError={submitError}
        submitSuccess={submitSuccess}
      />
      <EmailCancellationForm
        insuranceDetails={insuranceDetails}
        setSubmitError={setSubmitError}
        setSubmitSuccess={setSubmitSuccess}
      >
        <EmailCancellationFormFields submitSuccess={submitSuccess} />
        <EmailCancellationFormButtons
          insuranceProduct={insuranceProduct}
          submitSuccess={submitSuccess}
        />
      </EmailCancellationForm>
    </Container>
  );
};
